import {BASE_URL, getUserName} from '../../../Utils/constants'
import axios from 'axios'
import {
  readIncidentReportsForGraphResponseType,
  reportListTypeFromServer,
  uploadIncidentReportResponse,
} from './model'

const GET_INCIDENT_REPORTS_URL = `${BASE_URL}/ReportChartApp/src/api.php`
const UPLOAD_INCIDENT_REPORTS_URL = `${BASE_URL}/ReportChartApp/src/api.php`
const READ_INCIDENT_REPORTS_GRAPH_URL = `${BASE_URL}/ReportChartApp/src/api.php`

export const getIncidentReports = () => {
  const userName = getUserName()
  if (!userName) {
    throw new Error('Unauthorized user')
  }
  const url = GET_INCIDENT_REPORTS_URL
  const request = {
    function: 'getListOfExcelForUserByType',
    reportType: 'incident',
    username: userName,
  }
  return axios.post<{data: reportListTypeFromServer[]; success: boolean}>(url, request)
}

export const uploadIncidentReport = (file: File) => {
  const userName = getUserName()
  if (!userName) {
    throw new Error('Unauthorized user')
  }
  const url = UPLOAD_INCIDENT_REPORTS_URL
  const headers = {headers: {'Content-Type': 'multipart/form-data'}}
  const formData = new FormData()
  formData.append('function', 'uploadExcel')
  formData.append('reportType', 'incident')
  formData.append('username', userName)
  formData.append('file', file)
  return axios.post<uploadIncidentReportResponse>(url, formData, headers)
}

export const readGraphData = (reportIds: number[]) => {
  const url = READ_INCIDENT_REPORTS_GRAPH_URL
  const request = {
    function: 'getGraphDataByReportTypeAndDateOrExcelIds',
    reportType: 'incident',
    username: 'usnatekdemo',
    reportIds: [...reportIds],
  }

  return axios.post<readIncidentReportsForGraphResponseType>(url, request)
}
